export const isBrowser = typeof window !== 'undefined';

/**
 * Detect if the application is running in Docker environment
 * Uses the existing NEXT_PUBLIC_CONFIG_ENV variable to detect Docker
 */
export const isDocker = process.env.NEXT_PUBLIC_CONFIG_ENV === 'docker';
